import { ExtractedData, Configuration, ValueObject } from '../types/dataInputTypes';

const isValueObjectWithSensor = (obj: any): obj is ValueObject => {
  return obj && typeof obj === 'object' && 'value' in obj && !!obj.sensortag;
};

export const createSavePayload = (extractedData: ExtractedData[] | null): Configuration[] => {
  const configurations: Configuration[] = [];
  
  if (!extractedData || extractedData.length === 0) {
    return [];
  }

  const dataObject = extractedData[0];

  for (const rowKey in dataObject) {
    const rowContent = dataObject[rowKey];

    if (rowContent && typeof rowContent === 'object') {
      for (const columnKey in rowContent) {
        const cellData = (rowContent as any)[columnKey];

        if (isValueObjectWithSensor(cellData)) {
          configurations.push({
            sensorId: cellData.sensortag,
            value: cellData.value,
          });
        }
      }
    }
  }

  return configurations;
};
